import React, { FC, useMemo, useCallback, useRef, useState } from 'react'
import { Center, useRadio, Flex, Spinner } from '@chakra-ui/react'
import { Box, Image, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import { logoImageMap } from '../../state/interfaces'
import { RadioButton } from './radio-button'

export const MixedLargePillRadioButtonProvince: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props)
  const image = useMemo(() => (props.image ? logoImageMap[props.image] : ''), [props])
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleClick = useCallback((event) => {
    event.stopPropagation()
  }, [])

  const [isLoading, setIsLoading] = useState(true)

  return (
    <Flex as="label" cursor="pointer" data-testid={`pill-${props.value}`} display="flex" justifyContent="center">
      <Center
        {...getCheckboxProps()}
        margin={2}
        padding={2}
        border="3px solid #D8D8D8"
        borderStyle="solid"
        borderRadius="lg"
        backgroundColor="white"
        _hover={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
        _checked={{
          borderColor: 'brand',
        }}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
        tabIndex={0}
        onFocus={handleFocus}
        onClick={(event) => handleClick(event)}
      >
        <RadioButton {...getInputProps()} ref={inputRef} />

        <Box
          width={['70px', '115px']}
          minHeight={['80px', '140px']}
          borderRadius="lg"
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
        >
          <div style={{ flex: '60%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isLoading && <Spinner color={'black'} />}
            <Image
              src={image}
              onLoad={() => {
                if (isLoading) setIsLoading(false)
              }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              width="75%"
              height="75%"
              borderRadius="100%"
            />
          </div>
          {!isLoading && (
            <div style={{ flex: '40%', display: 'flex' }}>
              <Text fontSize={['8px', '14px']} fontWeight="bold" color={'black'}>
                {props.initials}
              </Text>
            </div>
          )}
        </Box>
      </Center>
    </Flex>
  )
}
